import * as d3 from 'd3';
import { VACCINATION_CHARTS_LEFT_PADDING, VACCINATION_CHARTS_RIGHT_PADDING, VACCINATION_CHARTS_BAR_HEIGHT } from '../constants';
import { scaled } from '../utils';
import dayjs from 'dayjs';

export default function() {
  // required parameters
  let data;

  // constants
  const padding = [20, VACCINATION_CHARTS_RIGHT_PADDING, 30, VACCINATION_CHARTS_LEFT_PADDING];
  const datePadding = 7 * 3;

  // variables
  let height;

  const chart = function(selection) {
    selection.each(function() {
      height = (data.length * VACCINATION_CHARTS_BAR_HEIGHT) + padding[0] + padding[2];

      const container = d3.select(this);

      container.attr('id', 'when-vaccinated')
        .attr('class', 'chart');

      const svg = container.append('svg')
        .attr('viewBox', `0 0 ${width} ${height}`)
        .attr('preserveAspectRatio', 'xMinYMin meet');

      const extent = d3.extent(data, d => d.date);
      const minDate = dayjs(extent[0]).subtract(datePadding, 'day').toDate();
      const xScale = d3.scaleTime()
        .domain([minDate, extent[1]])
        .range([0, width - (padding[1] + padding[3])]);

      const yScale = d3.scaleBand()
        .domain(data.map(d => d.country))
        .range([padding[0], height - padding[2]])
        .paddingInner(0.1);

      svg.selectAll('.value-bar')
        .data(data)
        .join('rect')
        .attr('class', d => d.country === 'Ireland' ? 'value-bar value-bar--highlighted' : 'value-bar')
        .attr('x', padding[3])
        .attr('y', d => yScale(d.country))
        .attr('test', d => xScale(d.date))
        .attr('width', d => xScale(d.date))
        .attr('height', yScale.bandwidth());

      xScale.ticks().forEach(tick => {
        const x = padding[3] + xScale(tick);
        svg.append('line')
          .attr('class', 'tick-line')
          .attr('x1', x)
          .attr('y1', padding[0])
          .attr('x2', x)
          .attr('y2', height - padding[2]);
      });

      // value (date)
      svg.selectAll('.value')
        .data(data)
        .join('text')
        .attr('class', 'value')
        .attr('x', d => xScale(d.date) + padding[3] - 8)
        .attr('y', d => yScale(d.country) + (yScale.bandwidth() / 2))
        .attr('test', d => xScale(d.date))
        .attr('alignment-baseline', 'central')
        .text(d => d3.timeFormat('%-d %b')(d.date));

      // country
      svg.selectAll('.country')
        .data(data)
        .join('text')
        .attr('class', d => d.country === 'Ireland' ? 'country country--highlighted' : 'country')
        .attr('x', padding[3] - 8)
        .attr('y', d => yScale(d.country) + (yScale.bandwidth() / 2))
        .attr('alignment-baseline', 'central')
        .text(d => d.country);

      // x-axis
      svg.append('g')
        .attr('class', 'axis x-axis')
        .attr('transform', `translate(${padding[3]} ${height - padding[2] + 10})`)
        .call(d3.axisBottom(xScale));
    })
  };

  chart.data = function(_) {
    if (!arguments.length) return data;
    data = _;
    return chart;
  };

  return chart;
}
